export default __webpack_public_path__ + "static/media/details-4.f2053654.jpg";